import smu_1 from '../../../assets/images/smu1.png';
import smu_2 from '../../../assets/images/smu3.png';
import smu_3 from '../../../assets/images/smu2.png';
import smu_4 from '../../../assets/images/smu4.png';
import smu_5 from '../../../assets/images/smu5.png';

const slides = [
    {
        id: 1,
        image: smu_1,
    },
    {
        id: 2,
        image: smu_2,
    },
    {
        id: 3,
        image: smu_3,
    },
    {
        id: 4,
        image: smu_4,
    },
    {
        id: 5,
        image: smu_5,
    },
]

export default slides